/* eslint-disable no-invalid-this */
/* eslint-disable max-lines-per-function */
import jtabs from 'extensions/jtabs';

// eslint-disable-next-line
const pagesProdCarousel  = function (carouselInstance) {
	const customCarousel = carouselInstance;

	const carouselOptions = {
		appendArrows: '.landing-featured-prods .product-carousel',
		draggable: false,
		responsive: [
			{
				breakpoint: 960,
				settings: {
					rows: 2,
					slidesPerRow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					rows: 1,
					slidesPerRow: 1
				}
			}
		],
		rows: 2,
		slidesPerRow: 2
	};
	const mobileOptions = {
		draggable: false,
		slidesToScroll: 1,
		slidesToShow: 1
	};

	// Mobile
	$('.landing-featured-prods').each(function () {
		if ($(this).hasClass('landing-featured-prods--initialized')) {
			return;
		}

		$(this).addClass('landing-featured-prods--initialized');
		const mobileContainer = $(this).find('.mobile-featured-carousel');
		const	desktopContainer = $(this).find('.product-carousel');
		const	parentContainer = $(this);

		parentContainer.find('.category-product').each(function () {
			const slideElement = $(this).clone();
			mobileContainer.append(slideElement);
		});

		customCarousel(mobileContainer, mobileOptions);
		customCarousel(desktopContainer, carouselOptions);
	});
};

const landingProdCarousel = function (customCarouselIntance) {
	const customCarousel = customCarouselIntance;
	let carouselOptions = {};
	if ($('body').width() > 767) {
		carouselOptions = {
			appendArrows: '.landing-featured-prods .product-carousel',
			draggable: false,
			responsive: [
				{
					breakpoint: 960,
					settings: {
						rows: 2,
						slidesPerRow: 3
					}
				}
			],
			rows: 2,
			slidesPerRow: 2
		};
	} else {
		carouselOptions = {
			centerMode: true,
			draggable: false,
			infinite: true,
			slide: '.category-product',
			slidesToScroll: 1,
			slidesToShow: 1
		};
	}

	$('.landing-featured-prods .product-carousel').each(function () {
		let $container = $(this);
		if ($container.hasClass('slick-initialized')) {
			$container.slick('unslick');
		}
		customCarousel($container, carouselOptions);
	});
};

export default async function () {
	const toggleTabs = function () {
		$('.landing-component .toggle-tabs').each(function () {
			const $container = $(this);
			const $showFirst = $(this).data('tt-show-first');
			if ($(this).hasClass('landing-component--initialized')) {
				return;
			}

			$(this).addClass('landing-component--initialized');

			$container.find('.toggle-header').attr({
				'aria-expanded': false,
				role: 'button'
			});

			if ($showFirst === false || $showFirst === 'false') {
				$container.find('.toggle-content').hide();
			} else {
				$container.find('.toggle-header:eq(0)').attr({
					'aria-expanded': true,
					role: 'button'
				});
				$container.find('.toggle-header').first().addClass('active');
				$container.find('.toggle-content:eq(0)').addClass('show').attr('aria-hidden', false);
				$container.find('.toggle-content:gt(0)').hide().attr('aria-hidden', true);
			}

			$(this).on('click', '.toggle-header', function () {
				const $currentElement = $(this);
				const $parentContainer = $(this).parents('.toggle-tabs');
				const $activeHeader = $parentContainer.find('.toggle-header.active');
				const $activeContent = $parentContainer.find('.toggle-content.show');

				if (!$currentElement.hasClass('active')) {
					$activeHeader.toggleClass('active').attr('aria-expanded', false);
					$activeContent.slideToggle().toggleClass('show').attr('aria-hidden', true);
					$currentElement.toggleClass('active').attr('aria-expanded', true);
					$currentElement.next('.toggle-content').slideToggle().toggleClass('show')
						.attr('aria-hidden', false);
				}
			});
		});
	};

	if ($('.landing-component').length > 0) {
		const {default: customCarousel} = await import('extensions/custom-carousel');

		if ($('.landing-featured-prods').length > 0) {
			// Used on feature-products readyTheme Product List
			if ($('#borsheims-featured').length > 0) {
				landingProdCarousel(customCarousel);
				$(window).on('resize', $.debounced(function () {
					landingProdCarousel(customCarousel);
				}, 375));
			}
			// Used on component_featured_prods Ready Theme
			else {
				pagesProdCarousel(customCarousel);
			}
		}

		if ($('.landing-nav').length) {
			let componentHTML = '';
			$('.landing-component').each(function (index) {
				if ($(this).hasClass('landing-component--initalized')) {
					return;
				}

				$(this).addClass('landing-component--initalized');
				const componentID = $(this).attr('id');
				const componentLabel = $(this).data('label');

				const newIndex = index + 1;

				componentHTML += '<li><a data-index="0' + newIndex + '" class="smoothscroll  uppercase" href="#' + componentID + '" alt="' + componentLabel + '">' + componentLabel + '</a></li>';
			});

			$('.landing-nav').find('.landing-nav--menu').html(componentHTML);
		};

		if ($('.landing-shop-grid').length > 0) {
			$('.landing-shop-grid').each(function () {
				if ($(this).hasClass('landing-shop-grid--initalized')) {
					return;
				}

				$(this).addClass('landing-shop-grid--initalized');
				const mobileContainer = $(this).find('.mobile-shop-carousel');
				const parentContainer = $(this);

				parentContainer.find('.shop-grid-item').each(function () {
					const slideElement = $(this).clone();
					mobileContainer.append(slideElement);
				});

				customCarousel(mobileContainer, {
					draggable: false,
					infinite: true,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								centerMode: true,
								infinite: true,
								slidesToScroll: 1,
								slidesToShow: 1
							}
						}
					],
					slide: '.shop-grid-item',
					slidesToScroll: 3,
					slidesToShow: 3
				});
			});
		};

		const linkGridCarousels = document.querySelectorAll('.landing-link-grid .link-carousel');
		for (const linkGridCarousel of linkGridCarousels) {
			const desktopSlidesPerRow = linkGridCarousel.getAttribute('data-desktop-row') ?? 4;
			customCarousel('.link-carousel', {
				appendArrows: '.link-carousel',
				draggable: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							rows: 2,
							slidesPerRow: 3
						}
					},
					{
						breakpoint: 768,
						settings: {
							rows: 2,
							slidesPerRow: 2
						}
					}
				],
				rows: 2,
				slidesPerRow: desktopSlidesPerRow
			});
		}

		if ($('.landing-link-grid .link-no-carousel').length) {
			customCarousel('.link-no-carousel', {
				appendArrows: '.link-no-carousel',
				draggable: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							rows: 2,
							slidesPerRow: 3
						}
					},
					{
						breakpoint: 768,
						settings: {
							rows: 2,
							slidesPerRow: 2
						}
					}
				],
				rows: 2,
				slidesPerRow: 5
			});
		};

		if ($('.landing-tabs').length) {
			jtabs();
			if ($('.landing-tabs .landing-tabs--carousel').length) {
				var carouselOptions = {
					draggable: false,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToScroll: 3,
								slidesToShow: 3
							}
						},
						{
							breakpoint: 768,
							settings: {
								centerMode: true,
								slidesToScroll: 1,
								slidesToShow: 1
							}
						}
					],
					slidesToScroll: 6,
					slidesToShow: 6
				};
				customCarousel('.js-tab-item.active .landing-tabs--carousel', carouselOptions);

				$('.js-tab-item.active .landing-tabs--carousel').attr('data-loaded', true);

				$('.landing-tabs .tab').on('click', function () {
					const index = $(this).index();
					const tab = $('.tab-content:eq(' + index + ')');
					const carousel = tab.find('.landing-tabs--carousel');

					if (carousel.hasClass('slick-initialized') !== true) {
						setTimeout(function () {
							customCarousel(carousel, carouselOptions);
						}, 250);
					}

				});
			};
		};

		if ($('.landing-benefits').length || $('.toggle-tabs').length) {
			toggleTabs();
		};

		if ($('.landing-education').length) {
			$('.landing-education').each(function () {
				if ($(this).hasClass('landing-education--initalized')) {
					return;
				}

				$(this).addClass('landing-education--initalized');
				const carousel = $(this).find('.education-carousel');
				customCarousel(carousel, {
					draggable: false,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								centerMode: true,
								centerPadding: '150px',
								slidesToScroll: 1,
								slidesToShow: 1
							}
						},
						{
							breakpoint: 768,
							settings: {
								centerMode: true,
								centerPadding: '100px',
								slidesToScroll: 1,
								slidesToShow: 1
							}
						},
						{
							breakpoint: 640,
							settings: {
								centerMode: true,
								centerPadding: '10px',
								slidesToScroll: 1,
								slidesToShow: 1
							}
						}
					],
					slidesToScroll: 1,
					slidesToShow: 3,
					verticalSwiping: false
				});
			});
		};

	};
}
